import { keyframes } from '@emotion/react';
import { colors, spacing } from '../../style/theme';

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
`;

function Bone({
  width = '100%',
  height = 16,
  radius = 6,
}: {
  width?: string | number;
  height?: number;
  radius?: number;
}) {
  return (
    <div
      css={{
        width,
        height,
        borderRadius: radius,
        background: colors.gray9,
        animation: `${pulse} 1.5s ease infinite`,
      }}
    />
  );
}

export default function DashboardSkeleton() {
  return (
    <div
      css={{
        padding: spacing.xLarge,
        maxWidth: 1080,
        margin: '0 auto',
      }}
    >
      {/* Header */}
      <div css={{ marginBottom: spacing.large, paddingBottom: spacing.medium }}>
        <Bone width={340} height={28} />
        <div css={{ marginTop: spacing.xSmall }}>
          <Bone width={260} height={16} />
        </div>
      </div>

      {/* Stat tiles */}
      <div
        css={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: spacing.medium,
          marginBottom: spacing.large,
        }}
      >
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            css={{
              padding: spacing.medium,
              borderRadius: 12,
              background: colors.highlightSurface,
              display: 'flex',
              flexDirection: 'column',
              gap: spacing.xSmall,
            }}
          >
            <Bone width={90} height={14} />
            <Bone width={120} height={28} />
            <Bone width={100} height={14} />
          </div>
        ))}
      </div>

      {/* Section */}
      <Bone width={120} height={20} />
      <div
        css={{
          marginTop: spacing.small,
          borderRadius: 12,
          border: `1px solid ${colors.gray9}`,
          background: 'white',
          height: 160,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Bone width="60%" height={16} />
      </div>

      {/* Quick links */}
      <div css={{ marginTop: spacing.large }}>
        <Bone width={100} height={20} />
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: spacing.small,
            marginTop: spacing.small,
          }}
        >
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              css={{
                padding: spacing.default,
                borderRadius: 10,
                border: `1px solid ${colors.gray9}`,
                background: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: spacing.small,
              }}
            >
              <Bone width={40} height={40} radius={10} />
              <div css={{ flex: 1 }}>
                <Bone width="70%" height={14} />
                <div css={{ marginTop: 6 }}>
                  <Bone width="90%" height={12} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
